import React from 'react';
import fp from 'lodash/fp';
import { Table } from 'rsuite';
import PropTypes from 'prop-types';
import HeaderCell from '../widgets/custom-cell/HeaderCell';

const { Column, Cell } = Table;

const computeColumnWidth = label => {
  const MinWidth = 85;
  const MaxWidth = 180;
  const labelWidth = label.length * 10;
  if (labelWidth < MinWidth) return MinWidth;
  if (labelWidth > MaxWidth) return MaxWidth;
  return labelWidth;
};

const widthByColumn = {
  visit_count: 120,
  household_total_group: 165,
  household_total_sum: 160,
  age1: 100,
  age2: 100,
  age3: 100,
  age4: 100,
  outreach_id_group: 290
};

const ColumnType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  column: PropTypes.string.isRequired
});

export default class OutreachAggregateTable extends React.Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    columns: PropTypes.arrayOf(ColumnType)
  };

  static defaultProps = {
    columns: []
  };

  constructor(props) {
    super(props);
    this.state = {
      sortColumn: 'visit_count',
      sortType: 'asc',
      loading: false
    };

    this.handleSortColumn = this.handleSortColumn.bind(this);
  }

  getData() {
    const { data } = this.props;
    const { sortColumn, sortType } = this.state;
    return fp.orderBy(sortColumn, sortType, data);
  }

  getColumnWidth = (column, label) =>
    fp.getOr(computeColumnWidth(label), column, widthByColumn);

  handleSortColumn(sortColumn, sortType) {
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState({
        sortColumn,
        sortType,
        loading: false
      });
    }, 200);
  }

  render() {
    const { sortColumn, sortType, loading: sortLoading } = this.state;
    const { loading, columns } = this.props;

    return (
      <React.Fragment>
        <Table
          autoHeight
          minHeight={200}
          bordered
          cellBordered
          loading={loading || sortLoading}
          data={this.getData()}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={this.handleSortColumn}
        >
          {fp.map(
            ({ column, label }) => (
              <Column
                resizable
                sortable
                key={`column-${column}`}
                width={this.getColumnWidth(column, label)}
              >
                <HeaderCell>{label}</HeaderCell>
                <Cell dataKey={column} />
              </Column>
            ),
            columns
          )}
        </Table>
      </React.Fragment>
    );
  }
}
